<template>
    <div style="height: 100%">
    </div>
</template>

<i18n locale="en" lang="yaml">
    "用户名": "User Name"
    "密码": "Password"
    "登录": "Login"
    "语言": "Language"
    "请输入用户名": "Please input username"
    "请输入密码": "Please input password"
</i18n>

<script>
    import qs from 'qs';

    export default {
        data() {
            return {
                form: {
                    username: '',
                    password: ''
                },
                rules: {
                    username: [
                        {required: true, message: this.$t('请输入用户名')}
                    ],
                    password: [
                        {required: true, message: this.$t('请输入密码')}
                    ],
                }
            }
        },
        beforeMount() {
          sessionStorage.setItem("auth-token", this.$route.query.token);
          this.$root.loadUserInfo().then(() => {
            this.$root.loadMenus().then(() => {
              this.redirect();
            });
          });
        },
        methods: {
            login() {
                this.$utils.submit(this.$refs.form, "/login", qs.stringify(this.form), (data) => {
                    sessionStorage.setItem("auth-token", data);

                    this.$root.loadMenus().then(() => {
                        this.$root.loadUserInfo();
                        this.redirect();
                    });
                });
            },
            redirect() {
                if (this.$root.user.type === 'USER') {
                    location.href = this.$root.services[0]['path'];
                } else {
                    this.$router.push("/index");
                }
            },
            changeLocale(local) {
                this.$i18n.locale = local;
                localStorage.setItem("local", local);
                this.$router.go(0);
            }
        }
    }
</script>
<style scoped>
    .container {
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;
    }

    .login {
        width: 300px;
        margin: 0 auto;
        text-align: center;
    }

    .button {
        width: 100%;
    }
</style>